export const chargeServicesDrawer = {
  title: "Cargos y servicios",
  closeAria: "Cerrar",
  subtitle: {
    catalog: "Catálogo reutilizable para tus facturas",
    select: "Selecciona los conceptos que quieres añadir",
  },
  searchPlaceholder: "Buscar servicio…",
  createService: "Crear servicio",
  loading: "Cargando servicios…",
  empty: "Aún no tienes servicios. Crea el primero.",
  item: {
    vat: "IVA {vat}%",
    edit: "Editar",
    delete: "Eliminar",
  },
  footer: {
    selected: "{count} seleccionado | {count} seleccionados",
    createInvoice: "Crear factura con estos",
    addToInvoice: "Añadir a la factura",
  },
  form: {
    editTitle: "Editar servicio",
    newTitle: "Nuevo servicio",
    subtitle: "Concepto reutilizable para tus facturas",
    photoLabel: "Foto",
    optional: "opcional",
    uploadPhoto: "Subir",
    nameLabel: "Nombre",
    namePlaceholder: "Ej. Limpieza final",
    categoryLabel: "Categoría",
    categoryPlaceholder: "Ej. Limpieza",
    priceLabel: "Precio",
    vatLabel: "IVA",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Detalle que saldrá en la factura",
    cancel: "Cancelar",
    save: "Guardar cambios",
    create: "Crear servicio",
  },
  toasts: {
    loadError: "No se pudieron cargar los servicios.",
    photoError: "No se pudo subir la foto.",
    updated: "Servicio actualizado.",
    created: "Servicio creado.",
    saveError: "No se pudo guardar el servicio.",
    deleteError: "No se pudo eliminar.",
  },
  confirmDelete: '¿Eliminar "{name}" del catálogo?',
};
